import axios from "axios";
import { query } from "sinao-corejs";
// import currencies from "../dummy/currencies.json";

const settings = {
	state: () => ({
		currencies: [],
		currency: {
			name: "Euro",
			iso: "EUR",
			symbol: "&#8364;"
		},
		accentColor: {
			background: "#3974d2",
			foreground: "#ffffff"
		},
		technicalName: "Receipts->Provision",
		config: null,
		currencySetByLoadDocument: false,
		defaultConfig:null
	}),
	getters: {
		config(state) {
			return state.config;
		},
		currency(state) {
			return (state.currency.symbol + "").replace(/&#\d+;/gm, function(s) {
				return String.fromCharCode(s.match(/\d+/gm)[0]);
			});
		},
		currencySpacing(state) {
			const reg = new RegExp("&", "ig");
			if (state.currency.symbol.match(reg) === null)
				return state.currency.symbol.length;
			
			return state.currency.symbol.match(reg).length;
		},
	},
	mutations: {
		technicalName(state, payload) {
			state.technicalName = payload;
		},
		currencies(state, currencies) {
			state.currencies = currencies;
		},
		currency(state, currency) {
			state.currency = currency;
		},
		color(state, { slot, color }) {
			state.accentColor[slot] = color;
		},
		config(state, payload) {
			state.config = payload;
		},
		currencySetByLoadDocument(state, payload) {
			state.currencySetByLoadDocument = payload;
		},
		defaultConfig(state, payload) {
			state.defaultConfig = payload;
		}
	},
	actions: {
		async config({ commit }, appId) {
			try {
				const response = await query({
					operationId: "app.settings.get",
					params: {
						appId
					}
				});

				commit("config", response);

				return response;
			} catch (error) {
				throw new Error(error);
			}
		},
		async getCurrencies({ commit }) {
			try {
				const response = await axios({
					method: "GET",
					url: process.env.VUE_APP_CURRENCIES_URL
				});

				if (response && response.data && response.data.length) {
					commit("currencies", response.data);

					return response.data;
				}

				return response;
			} catch (error) {
				throw new Error(error);
			}
		},
		initCurrencyByIso({ state, commit }, { isoCode, from }) {
			const currency = state.currencies.find(c => c.iso === isoCode);
			if (currency !== undefined) {
				if (from === "loadDocument") {
					commit("currency", currency);
					commit("currencySetByLoadDocument", true);
				} else if (state.currencySetByLoadDocument === false) {
					commit("currency", currency);
				}
			} 
		}
	}
};

export default settings;
